import React, { useContext } from 'react'
import { NotificationDot } from '../../..'
import { FormContext } from '../context'

interface ICountBadgeProps {
  size?: 'small' | 'medium'
}

const CountBadge = ({ size = 'small' }: ICountBadgeProps) => {
  const { formMetaData, ignore } = useContext(FormContext)

  const totalCount = Object.entries(formMetaData.formItems).reduce((total, [key, value]) => {
    if (ignore.includes(key)) return total
    return total + (value.hasValue ? 1 : 0)
  }, 0)

  if (totalCount === 0) return null

  return <NotificationDot count={totalCount} size={size} />
}

CountBadge.displayName = 'Form.CountBadge'
export default CountBadge
